/**************************************************
 * Created by nanyuantingfeng on 11/08/2017 17:41.
 **************************************************/
import moment from 'moment'
import fnPredefine4Date, { formatWithTime } from './fnPredefine4Date'

export default (field = {}) => {
  const { defaultValue, withTime, dateTimeType, defaultWorkingTime } = field
  let start = 0,
    end = 0
  if (
    defaultValue.type === 'predefine' &&
    defaultValue.value !== 'submit.requisition' &&
    defaultValue.value !== 'submit.travelPlan'
  ) {
    //从申请单取值
    start = end = fnPredefine4Date(field)
    if (field.name === 'tripDatePeriod') {
      //住宿日期+1day
      end = formatWithTime(withTime, moment(start).add(1, 'days'), dateTimeType)
    }

    if (
      defaultWorkingTime &&
      defaultWorkingTime.enabled &&
      dateTimeType === 'YEAR_MONTH_DAY_TIME'
    ) {
      const amStart = (defaultWorkingTime.morning && defaultWorkingTime.morning.start) || '08:30'
      const pmEnd = (defaultWorkingTime.afternoon && defaultWorkingTime.afternoon.end) || '18:00'
      const [amStartHour, amStartMin] = amStart.split(':').map(Number)
      const [pmEndHour, pmEndMin] = pmEnd.split(':').map(Number)

      const startMoment = moment(start).hour(amStartHour).minute(amStartMin).second(0).millisecond(0)
      const endMoment = moment(end).hour(pmEndHour).minute(pmEndMin).second(0).millisecond(0)

      return {
        start: startMoment.valueOf(),
        end: endMoment.valueOf()
      }
    }

    return { start, end }
  }
}
